import React, { useContext, useEffect } from 'react';
import { mdiArrowLeft } from '@mdi/js';
import { MainContext } from '~/context';
import { LogoImage } from '~/shared/components/logoImage';
import history from '~/services/history';
import MdIcon from '~/shared/components/mdIcon';
import { useLocation } from 'react-router-dom';
import {
  Header,
  Title,
  PerfilContainer,
  // LoginTitle,
  TitleMobile,
  ButtonNewConsult,
  ImageContainer,
} from './styles';

const HeaderPharmaceutical = () => {
  const location = useLocation();
  const context = useContext(MainContext);
  const {
    buttonDisplay,
    setButtonDisplay,
    setShowHome,
    setValidated,
    setInputValue,
    loginDisplay,
    setAlertMessageOpen,
    setcaptchaValidation,
    redirectTo,
    setRedirectTo,
  } = context;

  useEffect(() => {
    if (location.pathname.startsWith('/receita')) {
      setRedirectTo('/receita');
    } else if (location.pathname.startsWith('/valida')) {
      setRedirectTo('/valida');
    }
  }, []);
  return (
    <>
      <Header loginDisplay={loginDisplay}>
        <ImageContainer>
          <LogoImage />
        </ImageContainer>
        <Title>
          Validação de <strong>Documentação Digital</strong>
        </Title>
        <PerfilContainer>
          {buttonDisplay && (
            <ButtonNewConsult
              onClick={() => {
                setButtonDisplay(false);
                setShowHome(true);
                setValidated(false);
                setInputValue('');
                setAlertMessageOpen(false);
                setcaptchaValidation(false);
                history.push(`${redirectTo}`);
              }}
            >
              <p>nova consulta</p>
              <MdIcon size={1.2} icon={mdiArrowLeft} color="white" />
            </ButtonNewConsult>
          )}

          {/* <LoginTitle href="/receita/login">
          Fazer login ou criar conta
        </LoginTitle> */}
        </PerfilContainer>
      </Header>
      <TitleMobile>
        <span>
          Validação de
          <strong> Documentação Digital</strong>
        </span>
      </TitleMobile>
    </>
  );
};

export default HeaderPharmaceutical;
